import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getResellerNetworkStats = () => {
  return axios.get(`${BASE_URL}/api/reports/network-stats`);
};

export const getSourceCountry = () => {
  return axios.get(`${BASE_URL}/api/reports/source-country`);
};

export const getDestinationCountry = () => {
  return axios.get(`${BASE_URL}/api/dashboard/destination-country`);
};

export const getSourceCountryUsageReport = (sFromDate, sToDate, token) => {
  return axios.get(
    `${BASE_URL}/api/reports/source-country-usage?sFromDate=${sFromDate}&sToDate=${sToDate}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getConnectedUsersReport = (sFromDate, sToDate) => {
  return axios.get(
    `${BASE_URL}/api/reports/connected-users?sFromDate=${sFromDate}&sToDate=${sToDate}`
  );
};

export const getBandwidthConsumeReport = (sFromDate, sToDate, token) => {
  return axios.get(
    `${BASE_URL}/api/reports/bandwidth-consume?sFromDate=${sFromDate}&sToDate=${sToDate}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getConnectedUsersMonthwiseReport = (sFromDate, sToDate, token) => {
  return axios.get(
    `${BASE_URL}/api/reports/connected-users-monthwise?sFromDate=${sFromDate}&sToDate=${sToDate}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getConcurrentUsersReport = (sFromDate, sToDate, token) => {
  return axios.get(
    `${BASE_URL}/api/reports/concurrent-users?sFromDate=${sFromDate}&sToDate=${sToDate}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

const fetchBandwidthConsumeData = async (monthStr) => {
  setLoad(true);
  const [sFromDate, sToDate] = getMonthRange(monthStr);
  if (keycloak.token && keycloak.tokenParsed?.reseller_id) {
    try {
      const response = await getBandwidthConsumeReport(sFromDate, sToDate, keycloak.token);
      if (response?.data?.header?.code === 200 && response?.data?.body?.data) {
        setBandwidthConsumeData(response.data.body.data);
      } else {
        setBandwidthConsumeData([]);
        message.error(response?.data?.header?.message || 'Failed to fetch bandwidth consume data');
      }
    } catch (error) {
      setBandwidthConsumeData([]);
      message.error('Failed to fetch bandwidth consume data');
    } finally {
      setLoad(false);
    }
  } else {
    setLoad(false);
  }
};

const BandwidthConsumeChart = ({ data }) => {
  const maxVal = Math.max(...data.map(d => Number(d.bandwidth_consumed)), 1000);
  let yMax = 1000;
  if (maxVal > 0) {
    if (maxVal <= 1000) yMax = 1000;
    else if (maxVal <= 2000) yMax = 2000;
    else if (maxVal <= 5000) yMax = 5000;
    else if (maxVal <= 10000) yMax = 10000;
    else yMax = Math.ceil(maxVal / 10000) * 10000;
  }
  const formatBandwidth = v => v >= 1000000 ? (v/1000000).toFixed(2) + ' GB' : v >= 1000 ? (v/1000).toFixed(2) + ' MB' : v + ' KB';
  return (
    <Card className="side-panel align-center">
      <h3 style={{ textAlign: 'left', marginBottom: 0 }}>Bandwidth Consume</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" label={{ value: 'Date', position: 'insideBottom', offset: -5 }} />
          <YAxis tickFormatter={formatBandwidth} domain={[0, yMax]} label={{ value: 'Bandwidth', angle: -90, position: 'insideLeft' }} />
          <Tooltip formatter={v => formatBandwidth(Number(v))} labelFormatter={l => l} />
          <Bar dataKey="bandwidth_consumed" fill="#2ca02c" barSize={30} />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
